// extracted by mini-css-extract-plugin
module.exports = {"section5":"Section5_section5__ERLpX"};